<ag-charts-angular
[id]="titleText"
class="h-full"
[options]="options"></ag-charts-angular>
